var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 13,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.66669H11.3333M23 9.66669H14.6667M8 15.5H18M23 15.5H21.3333M8 21.3334H9.66667M23 21.3334H13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 11.3333C13.9201 11.3333 14.6663 10.5871 14.6663 9.66667C14.6663 8.74619 13.9201 8 12.9997 8C12.0792 8 11.333 8.74619 11.333 9.66667C11.333 10.5871 12.0792 11.3333 12.9997 11.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 17.1666C20.5871 17.1666 21.3333 16.4205 21.3333 15.5C21.3333 14.5795 20.5871 13.8333 19.6667 13.8333C18.7462 13.8333 18 14.5795 18 15.5C18 16.4205 18.7462 17.1666 19.6667 17.1666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 23.0001C12.2541 23.0001 13.0003 22.2539 13.0003 21.3334C13.0003 20.4129 12.2541 19.6667 11.3337 19.6667C10.4132 19.6667 9.66699 20.4129 9.66699 21.3334C9.66699 22.2539 10.4132 23.0001 11.3337 23.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMobile);
export default __webpack_public_path__ + "static/media/settings_mobile.0396d2ae0d56f1c2167be7dcc433d87f.svg";
export { ForwardRef as ReactComponent };